import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./ProgramCalendar.css";
import { useTranslation } from "react-i18next";
import axios from "axios";

// Default Image
import DefaultImage from "../Assets/ProgramCalendarimg.png";

const BASE_URL = "https://admin.cmpranesh-admk.com";

const ProgramCalendar = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "ta";

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isMobile, setIsMobile] = useState(false);
  const [events, setEvents] = useState({});

  // ============================
  // Fetch Programs from Backend
  // ============================
useEffect(() => {
  axios
    .get("https://admin.cmpranesh-admk.com/api/getPrograms.php")
    .then((res) => {
      const formattedEvents = {};

      res.data.forEach((item) => {
        const dateKey = new Date(item.program_date)
          .toLocaleDateString("en-CA");

        formattedEvents[dateKey] = {
          title: {
            ta: item.title_ta,
            en: item.title_en,
          },
          image: `${BASE_URL}/${item.image}`,
        };
      });

      setEvents(formattedEvents);
    })
    .catch((err) => {
      console.error("Program fetch error:", err);
    });
}, []);


  // ============================
  // Responsive Check
  // ============================
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ============================
  // Selected Date Logic (FIXED)
  // ============================
  const selectedKey = selectedDate.toLocaleDateString("en-CA");

  const event = events[selectedKey] || {
    title: {
      ta: "வரவிருக்கும் நிகழ்ச்சி",
      en: "Upcoming Program",
    },
    image: DefaultImage,
  };

  // ============================
  // Date Display
  // ============================
  const formattedDate = selectedDate.toLocaleDateString(
    lang === "ta" ? "ta-IN" : "en-IN",
    {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    }
  );

  return (
    <div className="pcWrapper">
      {/* LEFT SECTION */}
      <div className="pcLeftSection">
        <p className="pcSmallTitle">
          {lang === "ta" ? "எங்கள் பார்ட்டி நிகழ்ச்சிகள்" : "Our Party Programs"}
        </p>

        <h2 className="pcMainTitle">{event.title[lang]}</h2>

        <img
          src={event.image}
          alt="Program"
          className="pcImage"
          onError={(e) => (e.target.src = DefaultImage)}
        />

        {isMobile && (
          <div className="pcMobileDateBox">
            <h3>
              {lang === "ta" ? "தேர்ந்தெடுக்கப்பட்ட தேதி" : "Selected Date"}
            </h3>
            <p>{formattedDate}</p>
          </div>
        )}
      </div>

      {/* RIGHT SECTION */}
      <div className="pcRightSection">
        <Calendar
          onChange={setSelectedDate}
          value={selectedDate}
          className="pcCalendar"
        />
      </div>
    </div>
  );
};

export default ProgramCalendar;
